import { all, call, put, takeLatest } from "redux-saga/effects";
import { actionTypes } from '../actions'
import * as ApiService from '../services'
import { sendPayload, sendPayloadFailure } from "./helper";

const { REQUEST, GET_ORG_DATA } = actionTypes

export function* handleGetOrgData() {
  try {
    const processTypes: Generator<string, number, string> = yield call(
      ApiService.getProcessType,
    )
    const timeZones: Generator<string, number, string> = yield call(
      ApiService.getTimeZone,
    )
    const countries: Generator<string, number, string> = yield call(
      ApiService.getCountries,
    )
    const currencies: Generator<string, number, string> = yield call(
      ApiService.getCurrencies,
    )
    const sectorTypes: Generator<string, number, string> = yield call(
      ApiService.getSectorTypes,
    )

    const response = {
      processTypes: processTypes as any ?? [],
      timeZones: timeZones ?? [],
      countries: countries ?? [],
      currencies: currencies ?? [],
      sectorTypes: sectorTypes ?? [],
    };
    console.log(response, "llllllll")

    yield sendPayload(response, GET_ORG_DATA)
  } catch (e) {
    yield sendPayloadFailure(e, GET_ORG_DATA);
  }
}

export const sagas = {
  watchgetUserData: takeLatest(GET_ORG_DATA[REQUEST], handleGetOrgData),
}